(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kr-product-description"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-kr-desc-more]').forEach(function (wrap) {
        var content = wrap.querySelector('.kr-desc-more__content');
        var limit = parseFloat(getComputedStyle(content).maxHeight) || 0;
        wrap.classList.toggle('is-short', content.scrollHeight <= limit + 24);
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.kr-desc-more__toggle');
      if (!btn) return;
      var wrap = btn.closest('[data-kr-desc-more]');
      var content = wrap.querySelector('.kr-desc-more__content');
      var open = !wrap.classList.contains('is-open');

      content.style.maxHeight = content.scrollHeight + 'px';
      if (!open) {
        content.offsetHeight;
        content.style.maxHeight = '';
      }

      wrap.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open);
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    window.addEventListener('load', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
